import { getTheme, IStyle, keyframes, mergeStyleSets } from "@fluentui/react"

export function getBwjSpinnerStyles(spinnerSize: string | number = 64) {
  const theme = getTheme();

  const spinAnimation = keyframes({
    '0%': {
      transform: 'rotateZ(0deg)',
    },
    '25%': {
      transform: 'rotateZ(90deg)',
    },
    '50%': {
      transform: 'rotateZ(180deg)',
    },
    '75%': {
      transform: 'rotateZ(270deg)',
    },
    '100%': {
      transform: 'rotateZ(360deg)',
    },
  });

  const spinner: IStyle = {
    animation: `${spinAnimation} 1.1s infinite cubic-bezier(0.53, 0.21, 0.29, 0.67)`,
    fontSize: spinnerSize,
    width: spinnerSize,
    height: spinnerSize,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: '0.1em',
    borderColor: theme.palette.neutralTertiary,
    borderTopColor: theme.palette.themePrimary,
    margin: '0 auto',
  };

  return mergeStyleSets({
    spinner,
  });
};